<template>
	<div class="lottery-admin">
		<div class="admin-section">
			<h3>设置今日中奖码</h3>
			<div class="form-group">
				<el-input
					v-model="winnerCode"
					placeholder="请输入8位中奖码"
					:maxlength="8"
					style="width: 300px; margin-right: 10px;"
				></el-input>
				<el-button type="primary" @click="setWinnerCodeByInput" :loading="submitting">
					手动设置
				</el-button>
			</div>
		</div>

		<div class="admin-section">
			<h3>或从今日参与者中选择中奖者</h3>
			<div class="form-group">
				<el-select
					v-model="selectedUserId"
					placeholder="请选择今日参与者"
					filterable
					style="width: 300px; margin-right: 10px;"
				>
					<el-option
						v-for="user in todayParticipants"
						:key="user.user_id"
						:label="user.nickname + ' - ' + user.lottery_code"
						:value="user.user_id"
					></el-option>
				</el-select>
				<el-button type="success" @click="setWinnerCodeByUser" :loading="submitting">
					设为中奖者
				</el-button>
			</div>
		</div>

		<div class="admin-section">
			<h3>今日抽奖数据</h3>
			<el-row :gutter="20">
				<el-col :span="8">
					<div class="stat-card">
						<div class="stat-label">今日参与人数</div>
						<div class="stat-value">{{ todayStats.total }}</div>
					</div>
				</el-col>
				<el-col :span="8">
					<div class="stat-card">
						<div class="stat-label">当前中奖码</div>
						<div class="stat-value highlight">{{ currentWinnerCode || '未设置' }}</div>
					</div>
				</el-col>
				<el-col :span="8">
					<el-button type="warning" @click="refreshData" :loading="refreshing">
						刷新数据
					</el-button>
				</el-col>
			</el-row>
		</div>

		<div class="admin-section">
			<h3>今日参与者列表</h3>
			<el-table :data="todayParticipants" border style="width: 100%;">
				<el-table-column prop="user_id" label="用户ID" width="100"></el-table-column>
				<el-table-column prop="nickname" label="昵称"></el-table-column>
				<el-table-column prop="lottery_code" label="抽奖码"></el-table-column>
				<el-table-column prop="createtime" label="参与时间"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import api from '../utils/axios.js'

export default {
	name: 'lottery-admin',
	data() {
		return {
			winnerCode: '',
			selectedUserId: null,
			todayParticipants: [],
			currentWinnerCode: '',
			submitting: false,
			refreshing: false,
			todayStats: {
				total: 0
			}
		}
	},
	methods: {
		async refreshData() {
			this.refreshing = true
			try {
				await this.getTodayParticipants()
				await this.getTodayWinner()
			} catch (e) {
				console.error('刷新数据失败', e)
			} finally {
				this.refreshing = false
			}
		},
		async getTodayParticipants() {
			try {
				const res = await api.requests({
					url: '/lottery/gettodayparticipants',
					method: 'post',
					data: {}
				})
				if (res.data.code === 1) {
					this.todayParticipants = res.data.data
					this.todayStats.total = res.data.data.length
				}
			} catch (e) {
				console.error('获取参与者失败', e)
			}
		},
		async getTodayWinner() {
			try {
				const res = await api.requests({
					url: '/lottery/gettodaywinner',
					method: 'post',
					data: {}
				})
				if (res.data.code === 1 && res.data.data) {
					this.currentWinnerCode = res.data.data.lottery_code
				} else {
					this.currentWinnerCode = ''
				}
			} catch (e) {
				console.error('获取中奖码失败', e)
			}
		},
		async setWinnerCodeByInput() {
			if (!this.winnerCode || this.winnerCode.length !== 8) {
				this.$message.warning('请输入8位中奖码')
				return
			}
			this.submitting = true
			try {
				const token = localStorage.getItem('usertoken')
				const res = await api.requests({
					url: '/lottery/setwinnercode',
					method: 'post',
					data: {
						code: this.winnerCode,
						token: token
					}
				})
				if (res.data.code === 1) {
					this.$message.success('设置成功')
					this.winnerCode = ''
					this.refreshData()
				} else {
					this.$message.error(res.data.msg || '设置失败')
				}
			} catch (e) {
				this.$message.error('设置失败')
			} finally {
				this.submitting = false
			}
		},
		async setWinnerCodeByUser() {
			if (!this.selectedUserId) {
				this.$message.warning('请选择参与者')
				return
			}
			this.submitting = true
			try {
				const token = localStorage.getItem('usertoken')
				const res = await api.requests({
					url: '/lottery/setwinnercode',
					method: 'post',
					data: {
						user_id: this.selectedUserId,
						token: token
					}
				})
				if (res.data.code === 1) {
					this.$message.success('设置成功')
					this.selectedUserId = null
					this.refreshData()
				} else {
					this.$message.error(res.data.msg || '设置失败')
				}
			} catch (e) {
				this.$message.error('设置失败')
			} finally {
				this.submitting = false
			}
		}
	},
	mounted() {
		this.refreshData()
	}
}
</script>

<style scoped>
.lottery-admin {
	padding: 20px;
}

.admin-section {
	margin-bottom: 40px;
	padding: 20px;
	background: #f9f9f9;
	border-radius: 8px;
}

.admin-section h3 {
	margin: 0 0 20px 0;
	color: #333;
	font-size: 18px;
	border-left: 4px solid #409eff;
	padding-left: 12px;
}

.form-group {
	display: flex;
	align-items: center;
}

.stat-card {
	background: #fff;
	padding: 20px;
	border-radius: 8px;
	text-align: center;
	box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.stat-label {
	font-size: 14px;
	color: #999;
	margin-bottom: 10px;
}

.stat-value {
	font-size: 28px;
	font-weight: bold;
	color: #333;
}

.stat-value.highlight {
	color: #e6a23c;
}
</style>
